import { RootState } from '../root.reducers';
import { SecurityPolicy, SecurityPolicyUiState } from './securityPolicy.types';

export const getSecurityPolicy = (state: RootState): SecurityPolicy[] => state.securityPolicy.entities;

export const getSecurityPolicyErrors = (state: RootState): { securityPolicy: string } => state.securityPolicy.errors;

export const getUiState = (state: RootState): SecurityPolicyUiState => state.securityPolicy.ui;
